import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Upload = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 31.2502C27 32.3547 26.1046 33.2502 25 33.2502C23.8954 33.2502 23 32.3547 23 31.2502V11.0786L15.9977 18.0809C15.2167 18.8619 13.9503 18.8619 13.1693 18.0809C12.3882 17.2998 12.3882 16.0335 13.1693 15.2525L23.5859 4.83579C23.6104 4.81131 23.6355 4.78754 23.661 4.76448C23.9674 4.4882 24.3596 4.30534 24.7929 4.26076C24.8614 4.25362 24.9306 4.25 25.0002 4.25C25.0781 4.25 25.1555 4.25455 25.2321 4.26349C25.6771 4.31544 26.0944 4.5158 26.4144 4.83579L36.831 15.2525C37.6121 16.0335 37.6121 17.2998 36.831 18.0809C36.05 18.8619 34.7837 18.8619 34.0026 18.0809L27 11.0783V31.2502ZM6.25 29.2502C7.35457 29.2502 8.25 30.1457 8.25 31.2502V39.5836C8.25 40.1582 8.47827 40.7093 8.8846 41.1156C9.29093 41.522 9.84203 41.7502 10.4167 41.7502H39.5833C40.158 41.7502 40.7091 41.522 41.1154 41.1156C41.5217 40.7093 41.75 40.1582 41.75 39.5836V31.2502C41.75 30.1457 42.6454 29.2502 43.75 29.2502C44.8546 29.2502 45.75 30.1457 45.75 31.2502V39.5836C45.75 41.2191 45.1003 42.7876 43.9438 43.9441C42.7873 45.1005 41.2188 45.7502 39.5833 45.7502H10.4167C8.78116 45.7502 7.21265 45.1005 6.05617 43.9441C4.8997 42.7876 4.25 41.2191 4.25 39.5836V31.2502C4.25 30.1457 5.14543 29.2502 6.25 29.2502Z"
        fill={color}
      />
    </svg>
  )
}
